type SupabaseEnvironment = {
    DEV?: boolean;
    MODE?: string;
    VITE_SUPABASE_URL?: string;
    VITE_SUPABASE_ANON_KEY?: string;
};

const production = {
    url: 'https://api.lopaka.app/v1',
    storageKey: 'sb-gyzuqeguaxgkzpavcejr-auth-token',
    // Public anon key; authorization is enforced by database policies.
    anonKey:
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imd5enVxZWd1YXhna3pwYXZjZWpyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTk3NDEwMTAsImV4cCI6MjAzNTMxNzAxMH0.8ONWzl8smPflFv2eZ2QugeCEgMqQL9V33fHOAgcrz90',
};

export function resolveSupabaseConfig(env: SupabaseEnvironment) {
    if (env.MODE === 'e2e' || !env.DEV || (!env.VITE_SUPABASE_URL && !env.VITE_SUPABASE_ANON_KEY))
        return {...production};
    if (!env.VITE_SUPABASE_URL || !env.VITE_SUPABASE_ANON_KEY) {
        throw new Error('Local Supabase requires both VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY.');
    }
    const url = new URL(env.VITE_SUPABASE_URL);
    if (!['localhost', '127.0.0.1', '[::1]'].includes(url.hostname) || !['http:', 'https:'].includes(url.protocol)) {
        throw new Error('Development Supabase overrides must point to a local endpoint.');
    }
    return {
        url: env.VITE_SUPABASE_URL.replace(/\/$/, ''),
        anonKey: env.VITE_SUPABASE_ANON_KEY,
        storageKey: `lopaka-local-supabase-${url.host}`,
    };
}

const config = resolveSupabaseConfig({
    DEV: import.meta.env?.DEV,
    MODE: import.meta.env?.MODE,
    VITE_SUPABASE_URL: import.meta.env?.VITE_SUPABASE_URL,
    VITE_SUPABASE_ANON_KEY: import.meta.env?.VITE_SUPABASE_ANON_KEY,
});
export const supabaseUrl = config.url;
export const supabaseAuthStorageKey = config.storageKey;
export const supabaseAnonKey = config.anonKey;
